import TwoColDetailRow from './TwoColDetailRow';

export default TwoColDetailRow;
